import { useTranslation } from 'react-i18next';
import { useUserPermissions, useUserRoles } from '@anytag/auth';
import { Tabs } from '@anytag/shared-atoms';

export interface AgencyTabsProps {
  agencyId: number;
}

export const AgencyTabs = ({ agencyId }: AgencyTabsProps) => {
  const { t } = useTranslation();
  const { isAdminStaffAgencyTalentAgencyPartner } = useUserRoles();
  const { hideUserTab } = useUserPermissions();

  return (
    <Tabs
      options={[
        {
          end: true,
          label: t('Agency'),
          to: '/agency/$id',
          params: { id: agencyId.toString() }
        },
        {
          label: t('Business Associates'),
          hidden: !isAdminStaffAgencyTalentAgencyPartner,
          to: '/agency/$id/business',
          params: { id: agencyId.toString() }
        },
        {
          end: true,
          label: t('User'),
          hidden: hideUserTab,
          to: '/agency/$id/users',
          params: { id: agencyId.toString() }
        }
      ]}
      className="px-4"
    />
  );
};
